import React from 'react'
import { connect } from 'react-redux'

import { RouteSearch } from '../layout'
import { ConnectedLocationSearch } from '../../../../integrations/geolocation'
import ResultsCount from './ResultsCount.jsx'
import RoutesSortField from './RoutesSortField.jsx'
import FiltersButton from './FiltersButton.jsx'
import RouteFilters from './RouteFilters.jsx'
import RouteFiltersPreview from './RouteFiltersPreview.jsx'
import PrimaryFiltersMessage from './PrimaryFiltersMessage.jsx'
import SearchResults from './SearchResults.jsx'
import ViewSelector from './ViewSelector.jsx'
import { areFiltersDefault } from '../../helpers'

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ filters, primaryFilters }) => ({
    filtersChanged: !areFiltersDefault(filters),
    renderLocationSearch: () => <ConnectedLocationSearch />,
    renderResultsCount: () => <ResultsCount />,
    renderSortField: () => <RoutesSortField />,
    renderFiltersButton: props => <FiltersButton {...props} />,
    renderFilters: () => <RouteFilters />,
    renderFiltersPreview: props => <RouteFiltersPreview {...props} />,
    renderPrimaryFilters: () => !!primaryFilters && <PrimaryFiltersMessage />,
    renderResults: () => <SearchResults />,
    renderViewSelector: () => <ViewSelector />,
})

export default connect(mapStateToProps)(RouteSearch)
